import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class SupplierMeterTableHeader extends Component {

  static Layout = [
    { column: "serialNumber", width: 2, name: "Serial No." },
    { column: "meterType", width: 2, name: "Meter Type" },
    { column: "fromReading", name: "Previous Reading" },
    { column: "fromReadingDate", name: "Previous Date" },
    { column: "fromReadingType", name: "Previous Type" },
    { column: "toReading", name: "Present Reading" },
    { column: "toReadingDate", name: "Present Date" },
    { column: "toReadingType", name: "Present Type" },
    { column: "consumption" }
  ];

  render()
  {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={SupplierMeterTableHeader.Layout}/>
    )
  }
}